import { render, staticRenderFns } from "./errorState.vue?vue&type=template&id=2bc1b868"
import script from "./errorState.vue?vue&type=script&lang=ts"
export * from "./errorState.vue?vue&type=script&lang=ts"
import style0 from "./errorState.vue?vue&type=style&index=0&id=2bc1b868&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports